const MeldungMetadaten = () => {
    return {
        wohnortIstHaltungsort:{
            value: null,
            valide: null,
        },
    }
}
export default MeldungMetadaten;